export const DESIGN_VARIANTS = {
  DEFAULT: "default",
  MONO: "mono",
} as const;

export type DesignVariant = (typeof DESIGN_VARIANTS)[keyof typeof DESIGN_VARIANTS];

// The "mono" branding is the only one that uses the mono design.
export const IS_MONO_DESIGN = import.meta.env.VITE_BRANDING === "mono";

// Set per build, so every tenant served by one build shares the same design.
export const DESIGN_VARIANT: DesignVariant = IS_MONO_DESIGN
  ? DESIGN_VARIANTS.MONO
  : DESIGN_VARIANTS.DEFAULT;
